import { isNotNilOrEmpty } from '@pcty/utils';
/**
 * Filters and formats a value as US currency
 *
 * @param {number} value The value to format
 * @returns {string} The formatted string
 */
export var currencyUSDFormatter = function (value) {
    return isNotNilOrEmpty(value) ? value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '';
};
